export default __webpack_public_path__ + "static/media/back.14f0c29e.svg";